export const errorsInitialState = {
    travelDate: null,
    departureStationId: null,
    destinationStationId: null,
    userEmail: null,
    tosAndPrivacyPolicy: null,
}